import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-acordeon-item',
  templateUrl: './acordeon-item.component.html',
  styleUrls: ['./acordeon-item.component.scss']
})
export class AcordeonItemComponent implements OnInit, AfterViewInit {

  @Input() title = '';
  @Input() opened = false;
  @Input() index = '0';
  @Input() paddingBottom = 0;

  @Output() onToggleOpen = new EventEmitter<number>();

  @ViewChild('content') content: ElementRef;

  contentHeigth = '0px';


  constructor() { }

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(_ => {
      this.calculateContentSize();
    })
  }

  toggleOpen() {
    this.opened = !this.opened;
    this.onToggleOpen.emit(Number(this.index))
  }

  calculateContentSize() {
    this.contentHeigth = (this.content.nativeElement.scrollHeight + this.paddingBottom) + 'px';
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/acordeon/acordeon-item/acordeon-item.component.ts